import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";

const EventsPage = () => {
  return (
    <div data-testid="events-page" className="bg-[#0B1A3B] pt-16 md:pt-20">
      <section className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1A3B] via-[#0F2251] to-[#0B1A3B]" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#D4AF37]/[0.03] rounded-full blur-[100px]" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Events</p>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white mb-4">Upcoming Events</h1>
          <p className="text-lg text-white/50 max-w-2xl mx-auto">
            Join us at events across Nevada. Meet Cooper, ask questions, and be part of the movement.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 relative">
        <div className="absolute inset-0 bg-[#0F2251]" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center py-16 bg-white/[0.03] border border-white/10 p-8">
            <Calendar className="w-16 h-16 mx-auto text-[#D4AF37] mb-6" />
            <h2 className="text-2xl font-bold text-white mb-4">Coming Soon</h2>
            <p className="text-white/40 mb-8 max-w-md mx-auto">
              We're planning campaign events across Nevada. Sign up to be the first to know when events are announced.
            </p>
            <Link to="/volunteer" data-testid="events-volunteer-btn" className="inline-block px-8 py-4 bg-[#D4AF37] hover:bg-[#B5952F] text-black font-bold uppercase tracking-widest text-sm transition-all hover:-translate-y-0.5 hover:shadow-[0_20px_40px_-12px_rgba(212,175,55,0.3)]">
              Sign Up for Updates
            </Link>
          </div>

          <div className="mt-12 bg-white/[0.03] border border-white/10 p-8 text-center">
            <h2 className="text-lg font-bold text-white mb-4">Want to Help Plan Events?</h2>
            <p className="text-white/40 mb-6">We're looking for volunteers to help organize events in your community.</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/volunteer" className="px-8 py-4 border border-white/20 text-white hover:bg-white/10 font-bold uppercase tracking-widest text-sm transition-all">Volunteer</Link>
              <Link to="/contact" data-testid="events-contact-btn" className="px-8 py-4 bg-[#D4AF37] hover:bg-[#B5952F] text-black font-bold uppercase tracking-widest text-sm transition-all">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventsPage;
